import { render, staticRenderFns } from "./Concent.vue?vue&type=template&id=6f7e591a&"
import script from "./Concent.vue?vue&type=script&lang=ts&"
export * from "./Concent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports